import type { BlockExport } from "@circle-react-shared/BuilderUI/BuilderUI.types";
import { backgroundColor } from "@circle-react-shared/BuilderUI/constants/DefaultStyleAttributes/backgroundColor";
import { margin } from "@circle-react-shared/BuilderUI/constants/DefaultStyleAttributes/margin";
import { padding } from "@circle-react-shared/BuilderUI/constants/DefaultStyleAttributes/padding";
import {
  DesignProp,
  GeneralProp,
  MarginsProp,
  PaddingsProp,
} from "@circle-react-shared/BuilderUI/constants/PropCategories";
import { primaryBlockDefaultStyles } from "../../Homepage/constants";
import { BlogListingItemBlock as Block } from "./BlogListingItemBlock";
import { defaultData } from "./BlogListingItemBlockDefaultData";
import imagePreview from "./blog-listing-item-preview.png";

export const BlogListingItemBlock: BlockExport = {
  type: "component",
  Block,
  imagePreview: {
    type: "image-url",
    lg: imagePreview,
  },
  defaultData,
  meta: {
    name: "Blog Listing Item",
    version: 1,
    nameI18n: "builder_ui.block_type.blog_listing_item",
    isHidden: true,
    props: {
      image: {
        name: "Image",
        nameI18n: "builder_ui.prop_type.image",
        prop: "children",
        type: "children",
        accepts: ["Basic", "Media", "Text", "Actions", "Layout"],
      },
      content: {
        name: "Content",
        nameI18n: "builder_ui.prop_type.content",
        prop: "children",
        type: "children",
        accepts: ["Basic", "Media", "Text", "Actions", "Layout"],
      },
    },
    styles: {
      name: "Styles",
      nameI18n: "builder_ui.prop_type.styles",
      prop: "styles",
      type: "styles",
      attributes: {
        backgroundColor: {
          ...backgroundColor,
          category: [DesignProp, GeneralProp],
          defaultValue: primaryBlockDefaultStyles.backgroundColor,
        },
        padding: {
          ...padding,
          category: [DesignProp, PaddingsProp],
          defaultValue: primaryBlockDefaultStyles.padding,
        },
        margin: {
          ...margin,
          category: [DesignProp, MarginsProp],
          defaultValue: primaryBlockDefaultStyles.margin,
        },
      },
    },
  },
};
